import type { ReactNode } from 'react'

/**
 * The frame every unauthenticated screen shares: a single card centred on the
 * page canvas, matching the card the redesigned module screens use — white
 * surface, hairline border, `lg` radius (see the Add Customer wizard).
 *
 * `min-h-full` + `items-center` centres vertically on a tall viewport while
 * still allowing the page to scroll when the card outgrows it. Text alignment
 * is left to each screen.
 */
export function AuthLayout({ children }: { readonly children: ReactNode }) {
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-12">
      <main className="w-full max-w-md rounded-xl border border-border bg-surface p-8 shadow-lg shadow-fg/5 sm:p-10">
        {children}
      </main>
    </div>
  )
}
